module.exports = __webpack_public_path__ + "static/media/tire-repair-red.e99a6820.svg";